import { render, staticRenderFns } from "./InvoiceItemForm.vue?vue&type=template&id=3f6cc26a"
import script from "./InvoiceItemForm.vue?vue&type=script&lang=js"
export * from "./InvoiceItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports